import { Context } from "csi/def/Context";
import Heading from "csi/def/Heading";
import StringSelection from "csi/heading/StringSelection";
import locale from "csi/locale";
import reflection from "csi/reflection";
import xml from "csi/xml";
import Store from "dojo/store/api/Store";
import Memory from "dojo/store/Memory";
import declare from "dojo/_base/declare";


const UserDefaultAttributePathRenderer = declare(StringSelection, {
	getStore(ctx: Context, h: Heading): Store<object, object, object> {
		const allowedTypes = [xml.ATTR_BOOLEAN, xml.ATTR_ENUM, xml.ATTR_ENUMLIST];
		const typeUserDefaults = "UserDefaults";
		const data = [{ id: "", name: "" }];
		const rc = reflection.getClass(typeUserDefaults);
		const attributes = rc.getAttributes(false, true);

		attributes.forEach(({ attributeId, valueType }) => {
			if (allowedTypes.includes(valueType)) {
				data.push({ id: attributeId, name: locale.typeId(typeUserDefaults, attributeId) });
			}
		});

		return new Memory({
			data,
			idProperty: "id",
			labelProperty: "name",
		});
	},
});

export = UserDefaultAttributePathRenderer;